import React, { useState, useEffect } from 'react';




const Worklist = () => {
 
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Worklist</h4>
            <h6>Manage your daily tasks</h6>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Worklist;